import { Typography } from 'libs/ui/Typography';

export const InputLabel = ({ label }: { label: string }) => (
  <Typography className="input-label" title={label} variant="caption">
    {label}
  </Typography>
);
